import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import FormPremios from "./formPremios"
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'

const Premios = ()=> {

  const colunas = [
    {
      dataField: 'premio_id',
      text: 'Código'
    },
    {
      dataField: 'premio',
      text: 'Prêmio'
    },
    {
      dataField: 'num_pontos',
      text: 'Pontos'
    },
    {
      dataField: 'saldo',
      text: 'Estoque'
    }
  ]


  const { SearchBar }                     = Search
  const [loading, setLoading]             = useState(true)
  const [modal, setModal]                 = useToggle()
  const [premio_id, setPremio_id]         = useState('')
  const [listaPremio, setListaPremio]     = useState([])

  const listaPremios = () => {
    let lista = []
    const url = rotas.premio
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret !== '' && ret.success && ret.success === 'S'){
          lista = ret.lista
          setListaPremio(lista)
        }else{
          setListaPremio([])
        }
        setLoading(false)
      })
      return (lista)

    }catch(err){

    }
  }

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaPremios()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(modal === false){
      listaPremios()
    }
  }, [modal]) // eslint-disable-line react-hooks/exhaustive-deps

  //abrir modal do formulario
  const abreModal = (premio_id) => {
    setPremio_id(premio_id)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CADASTRO DE PRÊMIOS</CardTitle>
                </CardHeader>
                <CardBody>
                  <Modal
                    size   = 'xl'
                    isOpen = {modal}
                  >
                    <ModalHeader>Cadastro de Prêmios</ModalHeader>
                    <FormPremios
                      premio_id   = {premio_id}
                      fechaModal  = {setModal}
                    ></FormPremios>
                  </Modal>
                  <ToolkitProvider
                    keyField  = "Premio_id"
                    data      = {listaPremio}
                    columns   = {colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                  outline
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Prêmio..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField         = 'premio_id'
                            noDataIndication = "Nenhum registro encontrado"
                            rowStyle         = {{ cursor: "pointer" }}
                            pagination       = {paginationFactory({
                                                sizePerPage: 10,
                                                hideSizePerPage: true,
                                                hidePageListOnlyOnePage: true,
                                                showTotal: false,
                                                })}
                            rowEvents        = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.premio_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Premios;